import { ContentFocusValue } from '@/modules/contentCreator/ContentFocusTile';
import { TVerifyContentCreatorApplicationBody } from '@/services/api/requests/contentCreatorApplications';
import { create } from 'zustand';

export type CreatorApplicationFormData = {
  profilePhoto: File | null;
  creatorName?: string;
  keepNameSameAsRealName?: boolean;
  keepPhotoSameAsMemberPhoto?: boolean;
  existingProfilePhotoUrl?: string | null;
  aboutMe: string;
  city?: string;
  zipCode?: string;
  state?: string;
  socialMediaHandles: (string | undefined)[];
  qualifications: string[];
  contentFocus: ContentFocusValue[];
};

export type CreatorApplicationPreviewData = CreatorApplicationFormData & {
  profilePhotoPreview: string | null;
  applicantName?: {
    firstName: string;
    lastName: string;
  } | null;
};

type CreatorApplicationStoreState = {
  previewData: CreatorApplicationPreviewData | null;
  publicCredentials: TVerifyContentCreatorApplicationBody | null;
  setPreviewData: (previewData: CreatorApplicationPreviewData) => void;
  setPublicCredentials: (publicCredentials: TVerifyContentCreatorApplicationBody) => void;
  reset: () => void;
};

const initialState = {
  previewData: null,
  publicCredentials: null,
};

export const useCreatorApplicationStore = create<CreatorApplicationStoreState>()((set) => ({
  ...initialState,
  setPreviewData: (previewData) => set({ previewData }),
  setPublicCredentials: (publicCredentials) => set({ publicCredentials }),
  reset: () => set(initialState),
}));
